export const columnsExcel = [
  { key: 'codigo', header: 'Código' },
  { key: 'nombre', header: 'Nombre' },
  { key: 'grupo', header: 'Grupo' },
  { key: 'baseCobroDefault', header: 'Base de cobro' },
  { key: 'monedaDefault', header: 'Moneda' },
  { key: 'tarifaMinimaDefault', header: 'Tarifa mínima' },
  { key: 'modos', header: 'Modos' },
  { key: 'aliases', header: 'Alias' },
  { key: 'estado', header: 'Estado' },
  { key: 'updatedAt', header: 'Última actualización' },
];

/** Etiquetas de los modos de operación. */
export const MODOS = [
  { value: 'aereo', label: 'Aéreo' },
  { value: 'lcl', label: 'LCL' },
  { value: 'fcl', label: 'FCL' },
];

/** Color por grupo, para que la tabla se lea de un vistazo. */
export const GRUPO_BADGE = {
  'FLETE INTERNACIONAL': 'bg-blue-100 text-blue-800 border-blue-200',
  'GASTOS EN ORIGEN': 'bg-cyan-100 text-cyan-800 border-cyan-200',
  SEGURO: 'bg-violet-100 text-violet-800 border-violet-200',
  'GASTOS EN DESTINO': 'bg-emerald-100 text-emerald-800 border-emerald-200',
  'TRANSPORTE TERRESTRE OTM': 'bg-amber-100 text-amber-800 border-amber-200',
  DOCUMENTACIÓN: 'bg-slate-100 text-slate-800 border-slate-200',
  ADUANA: 'bg-rose-100 text-rose-800 border-rose-200',
  OTROS: 'bg-neutral-100 text-neutral-800 border-neutral-200',
};
